import { combineEpics } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { ActionsObservable } from 'redux-observable';
// actions
import { Actions as LoginActions } from 'modules/login';
import { Actions as EmailVerificationActions } from 'modules/email-verification';
// constants
import { Constants as LoginConstants } from 'modules/login';
import { Constants as UbisoftOverlayProviderConstants } from 'modules/ubisoft-connect-overlay-provider';
// types
import { IEpic } from 'types/epic';
import { IAction } from 'types/action';

const { resetEmailVerification } = EmailVerificationActions;
const { removeLoginSession, requestLoginSession } = LoginActions;

const { LOG_OUT_DONE } = LoginConstants;
const { LOAD_UBISOFT_OVERLAY_DONE } = UbisoftOverlayProviderConstants;

export const requestLoginSessionEpic: IEpic = (action$: ActionsObservable<IAction>) =>
    action$.ofType(LOAD_UBISOFT_OVERLAY_DONE).pipe(mergeMap(() => [requestLoginSession()]));

export const logOutEpic: IEpic = (action$: ActionsObservable<IAction>) =>
    action$.ofType(LOG_OUT_DONE).pipe(mergeMap(() => [removeLoginSession(), resetEmailVerification()]));

export default combineEpics(requestLoginSessionEpic, logOutEpic);
